(function () {
    'use strict';

    angular
        .module('styleVisualGuidelinesControllers', []);
})();
